export default "__VITE_ASSET__$vHg291y__"